import React, { useState, useEffect, useCallback } from "react";
import CustomModal from "./customModal";
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import { useSelector } from "react-redux";

export default function CustomerGroupSelectionModal({
  showModal,
  setShowModal,
  onSubmit,
  selectedGroups,
  setSelectedGroups,
  subtitle = "Select customer groups to apply the Discount",
}) {
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
  const [customerGroups, setCustomerGroups] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [tempSelectedGroups, setTempSelectedGroups] = useState(selectedGroups || []);
  const [loading, setLoading] = useState(false);

  const fetchCustomerGroups = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_CUSTOMERS_GROUP, {
        params: {
          CompID,
          Search: searchTerm || "",
          SortBy: "Name",
          SortOrder: "ASC",
        },
      });

      const groupData = response.data.data || [];
      if (Array.isArray(groupData)) {
        setCustomerGroups(groupData);
        setFilteredGroups(groupData);
      } else {

        setCustomerGroups([]);
        setFilteredGroups([]);
      }
    } catch (error) {

      setCustomerGroups([]);
      setFilteredGroups([]);
    } finally {
      setLoading(false);
    }
  }, [CompID, searchTerm]);

  useEffect(() => {
    if (showModal) {
      fetchCustomerGroups();
    }
  }, [showModal, fetchCustomerGroups]);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredGroups(customerGroups);
    } else {
      const filtered = customerGroups.filter((group) =>
        group.name?.toLowerCase().includes(searchTerm.trim().toLowerCase())
      );
      setFilteredGroups(filtered);
    }
  }, [searchTerm, customerGroups]);

  useEffect(() => {
    // Sync tempSelectedGroups with selectedGroups when modal opens
    setTempSelectedGroups(selectedGroups || []);
  }, [selectedGroups, showModal]);

  const handleGroupSelection = (group) => {
    setTempSelectedGroups((prev) => {
      if (prev.some((g) => g.id === group.id)) {
        return prev.filter((g) => g.id !== group.id);
      }
      return [...prev, group];
    });
  };

  const handleSubmit = () => {
    if (typeof onSubmit === "function") {
      onSubmit(tempSelectedGroups);
    }
    setSelectedGroups(tempSelectedGroups); // Update parent state on submit
    setShowModal(false); // Close modal after saving
  };

  return (
    <div>
      <CustomModal
        isOpen={showModal}
        title="Select Customer Groups"
        subtitle={subtitle}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        showButton={true}
        showCancelButton={true}
        showSubmitButton={true}
        submitButtonText="Done"
        isCentered={true}
      >
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search customer groups"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <span
              className="input-group-text"
              onClick={() => setSearchTerm("")}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-times"></i>
            </span>
          )}
        </div>

        <div style={{ height: "300px", overflowY: "auto" }}>
          <div className="table-responsive">
            <table className="table">
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="2" className="text-center py-3">
                      Loading...
                    </td>
                  </tr>
                ) : filteredGroups.length > 0 ? (
                  filteredGroups.map((group) => (
                    <tr key={group.id} className="bg-light bg-opacity-50">
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <span>{group.name}</span>
                        </div>
                      </td>
                      <td className="align-middle text-end" style={{ width: "50px" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
 

                            checked={tempSelectedGroups.some((g) => g.id === group.id)}
                            onChange={() => handleGroupSelection(group)}
                            id={`group-checkbox-${group.id}`}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center py-3">
                      No customer groups found
                      {searchTerm.length > 0 ? ` matching "${searchTerm}"` : ""}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}